<template>
  <div class="container-fluid">
    <!-- Modal Lost -->
    <div
      v-if="showReportCard === true"
      class="modal fade"
      id="lostConfirm"
      tabindex="-1"
      role="dialog"
      aria-labelledby="exampleModalCenterTitle"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <button
            type="button"
            class="close"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>

          <div class="modal-body">
            <p class="lostStol">
              Are you sure you want to cancel this card?
            </p>
            <a
              ><button
                v-if="isReportCardLostButtonLoading === true"
                data-dismiss="modal"
                v-on:click="updateCardStatusAsLost"
                disabled
              >
                <span
                  class="spinner-border spinner-border-sm"
                  role="status"
                  aria-hidden="true"
                ></span>
                Card cancelling...
              </button>
              <button
                v-if="isReportCardLostButtonLoading === false"
                data-dismiss="modal"
                v-on:click="updateCardStatusAsLost"
              >
                I am sure, Please cancel my card
              </button>
            </a>
            <a
              ><button data-dismiss="modal" class="white">
                I don't want to cancel my card
              </button></a
            >
          </div>
        </div>
      </div>
    </div>

    <!-- Modal Stolen -->
    <div
      v-if="showReportCard === true"
      class="modal fade"
      id="stolenConfirm"
      tabindex="-1"
      role="dialog"
      aria-labelledby="exampleModalCenterTitle"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <button
            type="button"
            class="close"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>

          <div class="modal-body">
            <p class="lostStol">
              Are you sure you want to cancel this card?
            </p>
            <a
              ><button
                v-if="isReportCardStolenButtonLoading === true"
                data-dismiss="modal"
                v-on:click="updateCardStatusAsStolen"
                disabled
              >
                <span
                  class="spinner-border spinner-border-sm"
                  role="status"
                  aria-hidden="true"
                ></span>
                Card cancelling...
              </button>
              <button
                v-if="isReportCardStolenButtonLoading === false"
                data-dismiss="modal"
                v-on:click="updateCardStatusAsStolen"
              >
                I am sure, Please cancel my card
              </button>
            </a>
            <a
              ><button data-dismiss="modal" class="white">
                I don't want to cancel my card
              </button></a
            >
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-md-8 profile">
        <!-- Without CMS -->
        <div v-if="isCmsUsed === false">
          <h2>Report Lost/Stolen</h2>

          <p>
            If you think you have lost this card, or it has been stolen, you can
            ell us 24 hours a day, 7 days a week on
          </p>

          <p>
            <strong
              >+44 20 34755351 (Europe) or +604 200 0554 (Americas).</strong
            >
          </p>

          <p>Alternatively, you can use the buttons below.</p>

          <p>
            Please be aware that once you have done this it cannot be reversed.
            Your card will be permanently cancelled and a new one sent to you by
            post.
          </p>

          <p>
            The charge for issuing a new card is <strong>£7.50</strong>. This
            will be deducted from your card balance.
          </p>
        </div>
        <!-- With CMS -->
        <div v-if="isCmsUsed === true" v-html="leftContent"></div>

        <div v-if="showReportCard === true">
          <a class="margRight"
            ><button
              type="button"
              data-toggle="modal"
              data-target="#lostConfirm"
            >
              Lost
            </button></a
          ><a
            ><button
              type="button"
              data-toggle="modal"
              data-target="#stolenConfirm"
            >
              Stolen
            </button></a
          >
          <div class="spacer-60"></div>
        </div>
      </div>

      <div class="col-md-4 promos">
        <Promotions />
      </div>
      <div class="col-md-4 promos promos2">
        <Promotions />
      </div>
    </div>
    <Cards />
    <footer>
      <div class="row">
        <div class="col-md-12">
          <p>
            This website hosted at URL Bonusme.uk is provided by Performance
            Bonus Ltd a company registered in England and Wales (registration
            number 4326332) Registered Office: 2 St Mary Street, Chepstow,
            Monmouthshire, NP16 5EU. The Card and electronic money (‘e-money’)
            loaded on it are issued by Payment Card Solutions (UK) Limited
            trading as B4B Payments, a company registered in England and Wales
            (registration number 05941947) and registered office at 21-24
            Millbank, London, England, SW1P 4QP. Payment Card Solutions (UK)
            Limited is authorised and regulated in the UK by the Financial
            Conduct Authority (Firm Reference Number: 930619) for the issuing of
            e-money. Mastercard is a registered trademark, and the circles
            design is a trademark of Mastercard International Incorporated.
          </p>
        </div>
      </div>
    </footer>
  </div>
</template>

<script>
import Cards from "./Cards.vue";
import actions from "@/store/cards/actions";
import Promotions from "./Promotions.vue";
export default {
  components: {
    Cards,
    Promotions
  },
  created() {
    this.leftContent =
      this.isCmsUsed === true &&
      this.cmsPage != undefined &&
      this.cmsPage.leftContent != null
        ? this.cmsPage.leftContent
        : "";
    this.showReportCard =
      this.isCmsUsed === false ||
      (this.isCmsUsed === true &&
        this.cmsPage != undefined &&
        this.cmsPage.showReportCard === true);
  },
  computed: {
    isCmsUsed: {
      get() {
        return this.$store.state.cms.isCmsUsed;
      }
    },
    cmsPage: {
      get() {
        return this.$store.state.cms.cmsPage;
      }
    },
    isCardLostActiveModale: {
      get() {
        return this.$store.state.settings.isCardLostActiveModale;
      },
      set(value) {
        this.$store.commit("updateIsCardLostModaleActiveMutation", value);
      }
    },
    isCardStolenActiveModale: {
      get() {
        return this.$store.state.settings.isCardStolenActiveModale;
      },
      set(value) {
        this.$store.commit("updateIsCardStolenModaleActiveMutation", value);
      }
    },
    cardGuid: {
      get() {
        return this.$store.state.accounts.fullAccountDetails.user?.cardGuid;
      }
    },
    isReportCardLostButtonLoading: {
      get() {
        return this.$store.state.settings.isReportCardLostButtonLoading;
      },
      set(value) {
        this.$store.commit(
          "updateIsReportCardLostButtonLoadingMutation",
          value
        );
      }
    },
    isReportCardStolenButtonLoading: {
      get() {
        return this.$store.state.settings.isReportCardStolenButtonLoading;
      },
      set(value) {
        this.$store.commit(
          "updateIsReportCardStolenButtonLoadingMutation",
          value
        );
      }
    }
  },
  methods: {
    updateCardStatusAsLost: async function() {
      window.$("#lostConfirm").modal("hide");
      this.isReportCardLostButtonLoading = true;
      await this.$store.dispatch(
        actions.PUT_CARD_STATUS_AS_LOST,
        this.cardGuid
      );
    },

    updateCardStatusAsStolen: async function() {
      window.$("#stolenConfirm").modal("hide");
      this.isReportCardStolenButtonLoading = true;
      await this.$store.dispatch(
        actions.PUT_CARD_STATUS_AS_STOLEN,
        this.cardGuid
      );
    }
  }
};
</script>
